import DashboardLink from "@dashboard/components/Link";
import { FulfillmentStatus, OrderDetailsFragment } from "@dashboard/graphql";
import { getStringOrPlaceholder } from "@dashboard/misc";
import { carrierLabel, resolveTracking } from "@dashboard/orders/utils/tracking";
import { Box, Paragraph, Text } from "@saleor/macaw-ui-next";
import clsx from "clsx";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { extraInfoMessages } from "./messages";
import useStyles from "./styles";

interface ExtraInfoLinesProps {
  fulfillment?: OrderDetailsFragment["fulfillments"][0];
  shippingMethodName?: string | null;
}

const ExtraInfoLines = ({ fulfillment, shippingMethodName }: ExtraInfoLinesProps) => {
  const intl = useIntl();
  const classes = useStyles({});

  if (!fulfillment || (!fulfillment.warehouse && !fulfillment.trackingNumber)) {
    return null;
  }

  const { warehouse, trackingNumber, status } = fulfillment;
  const tracking = trackingNumber
    ? resolveTracking(trackingNumber, { metadata: fulfillment.metadata, shippingMethodName })
    : null;

  return (
    <Box
      paddingY={4}
      paddingX={6}
      borderColor="default1"
      borderBottomStyle={"solid"}
      borderBottomWidth={1}
    >
      <Paragraph color="default2" fontSize={3}>
        {warehouse && (
          <>
            {intl.formatMessage(
              status === FulfillmentStatus.RETURNED
                ? extraInfoMessages.restocked
                : extraInfoMessages.fulfilled,
            )}
            <Text
              className={clsx(classes.infoLabel, {
                [classes.infoLabelWithMargin]: !!trackingNumber,
              })}
              color="default1"
              fontSize={3}
            >
              {getStringOrPlaceholder(warehouse?.name)}
            </Text>
          </>
        )}
      </Paragraph>
      <Paragraph color="default2" fontSize={3}>
        {tracking && (
          <FormattedMessage
            {...extraInfoMessages.tracking}
            values={{
              trackingNumber: tracking.url ? (
                <DashboardLink
                  href={tracking.url}
                  target="_blank"
                  data-test-id="tracking-number-set"
                  className={classes.infoLabel}
                  style={{ userSelect: "all" }}
                >
                  {tracking.label}
                </DashboardLink>
              ) : (
                <Text
                  data-test-id="tracking-number-set"
                  className={classes.infoLabel}
                  color="default1"
                  fontSize={3}
                  style={{ userSelect: "all" }}
                >
                  {tracking.label}
                </Text>
              ),
            }}
          />
        )}
        {tracking && carrierLabel(tracking.carrier) && (
          <Text className={classes.infoLabel} color="default2" fontSize={3}>
            {" "}
            ({carrierLabel(tracking.carrier)})
          </Text>
        )}
      </Paragraph>
    </Box>
  );
};

export default ExtraInfoLines;
